import { render, staticRenderFns } from "./PhoneComponent.vue?vue&type=template&id=8bd7060c&scoped=true"
import script from "./PhoneComponent.vue?vue&type=script&lang=js"
export * from "./PhoneComponent.vue?vue&type=script&lang=js"
import style0 from "./PhoneComponent.vue?vue&type=style&index=0&id=8bd7060c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd7060c",
  null
  
)

export default component.exports